import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAdminData } from '../hooks/useAdminData';
import { useUserData } from '../hooks/useUserData';

export function RequireUser({ children }: { children: ReactNode }) {
    const user = useUserData();
    const navigate = useNavigate();

    useEffect(() => {
        if (!user.logged) navigate('/');
    }, [user.logged, navigate]);

    if (!user.logged) return null;
    return <>{children}</>;
}

export function RequireAdmin({ children }: { children: ReactNode }) {
    const admin = useAdminData();
    const navigate = useNavigate();

    useEffect(() => {
        if (!admin.logged) navigate('/admin/login');
    }, [admin.logged, navigate]);

    if (!admin.logged) return null;
    return <>{children}</>;
}

export function RedirectIfLogged() {
    const admin = useAdminData();
    if (admin.logged) return <Navigate to="/admin/events" replace />;
    return null;
}
